<template>
  <div class="card">
    <div class="card-body">
      <b-container>
        <b-row v-if="treeData">
          <b-col sm="6" class="border">
            <div class=""><h4>Files</h4></div>
            <div class="overflow-auto">
              <tree-view @select-item="selectItem"></tree-view>
            </div>
          </b-col>
          <b-col sm="6" class="border p-0">
            <file-detail-card v-if="selectedChecksum && selectedSize"
              :name="selectedName"
              :checksum="selectedChecksum"
              :size="selectedSize"
              :key="selectedChecksum">
            </file-detail-card>
          </b-col>
        </b-row>
        <b-row v-else class="text-center p-3 h-fixed">
          No File Details Available
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import TreeView from '#/ui/Components/TreeView.vue';
import FileDetailCard from '#/ui/Components/FileDetailCard.vue';

export default {
  components: {
    TreeView,
    FileDetailCard,
  },
  mounted() {
    this.treeData = this.$store.getters['jobs/roots'](this.jobId);
  },
  created() {
    console.log('FileSearch:', this.rootEntities);
  },
  props: {
    jobId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      filter: '',
      selected: '',
      matchAll: {
        radio: 'radio1',
      },
      switches: {
        matchAny: false,
      },
      cursor: 0, // cursor for pagination
      currentPage: 0,
      limit: 10, // default limit for pagination
      loading: false, // to prevent a secondary request from being sent while we await a response.
      fullyLoaded: false, // to distinguish between an empty cursor suggesting. will be empty before first and after last load.
      mediaItems: [],
      selectedItem: null,
      treeData: []
    };
  },
  computed: {
    selectedName() {
      if (this.selectedItem && this.selectedItem.node) {
        return this.selectedItem.node.getDetails().getName();
      }
      return 'No Name';
    },
    selectedChecksum() {
      if (this.selectedItem && this.selectedItem.node) {
        const checksums = this.selectedItem.node.getDetails().getChecksums();
        // TODO: define the "DEFAULT" algorithm in a different location
        const xxhash = checksums ? checksums.getXxhash3128() : null;
        return xxhash;
      }
      return null;
    },
    selectedSize() {
      if (this.selectedItem && this.selectedItem.node) {
        const size = this.selectedItem.node.getDetails().getSize();
        return size;
      }
      return null;
    },
  },
  methods: {
    getRandomImage(index) {
      const randInt = Math.floor(Math.random() * Math.floor(100));
      return `https://i.picsum.photos/id/${randInt + index}/100/50.jpg`;
    },
    selectItem(item) {
      console.info('tree item selected id:', item.node.getNodeId(), 'size:', item.node.getDetails().getSize(), 'checksums:', item.node.getDetails().getChecksums().toObject());
      if (item.isDir) {
        const children = this.$store.getters['jobs/childrenOf'](this.jobId, item.node.getNodeId());
        Vue.set(item, 'children', children);
        // item.children.push(children);
      }
      this.selectedItem = item;
      // Vue.set(item, 'children', []);
      // this.addItem(item);
    },
  },
};
</script>
<style lang="scss" scoped>
.flex-container-thumb {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-align-content: stretch;
  -ms-flex-line-pack: stretch;
  align-content: stretch;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}
</style>
